export const TOGGLE_DIGITAL_SIGNATURE_DIALOG = "TOGGLE_DIGITAL_SIGNATURE_DIALOG"
export const TOGGLE_BILLING_PAYMENT_DIALOG = "TOGGLE_BILLING_PAYMENT_DIALOG"
export const TOGGLE_SEND_BILLING_DIALOG = "TOGGLE_SEND_BILLING_DIALOG"
export const TOGGLE_CLICK_CONFIRMATION_DIALOG =
  "TOGGLE_CLICK_CONFIRMATION_DIALOG"
export const TOGGLE_FLAGGING_DIALOG = "TOGGLE_FLAGGING_DIALOG"
export const TOGGLE_CREATE_SOLO_DIALOG = "TOGGLE_CREATE_SOLO_DIALOG"
export const TOGGLE_ADD_SOLO_POSITION_DIALOG = "TOGGLE_ADD_SOLO_POSITION_DIALOG"
export const TOGGLE_ADD_DISCOUNT_DIALOG = "TOGGLE_ADD_DISCOUNT_DIALOG"
export const TOGGLE_MANAGE_EXPENSES_DIALOG = "TOGGLE_MANAGE_EXPENSES_DIALOG"
export const TOGGLE_PAY_NOW_DIALOG = "TOGGLE_PAY_NOW_DIALOG"
export const TOGGLE_VIEW_TRANSFERS_DIALOG = "TOGGLE_VIEW_TRANSFERS_DIALOG"
export const TOGGLE_BILLING_ADJUSTMENT_DIALOG =
  "TOGGLE_BILLING_ADJUSTMENT_DIALOG"

export const TOGGLE_ADJUST_BILLING_DIALOG =
  "TOGGLE_ADJUST_BILLING_DIALOG"

export const TOGGLE_SOLO_REPRESENTATIVE_DIALOG =
  "TOGGLE_SOLO_REPRESENTATIVE_DIALOG"

export const TOGGLE_CLIENT_INVOICE_LOGS_DIALOG =
  "TOGGLE_CLIENT_INVOICE_LOGS_DIALOG"

//Add A Discount - seen by admin only
export const toggleAddDiscountDialog = (
  addDiscountDialogOpen = false,
  data
) => ({
  type: "TOGGLE_ADD_DISCOUNT_DIALOG",
  addDiscountDialogOpen,
  data: data,
})

// Crew member accept Deal Memo, client sign off on Estimate - seen by external
export const toggleDigitalSignatureDialog = (
  digitalSignatureDialogOpen = false,
  data
) => ({
  type: "TOGGLE_DIGITAL_SIGNATURE_DIALOG",
  digitalSignatureDialogOpen,
  data: data,
})

// Partial Payment, Final Payment and Final Balance dialog - seen by clients
export const toggleBillingPaymentDialog = (
  billingPaymentDialogOpen = false,
  data
) => ({
  type: "TOGGLE_BILLING_PAYMENT_DIALOG",
  billingPaymentDialogOpen,
  data: data,
})

// for both Send Invoice & Send Estimate dialog - internal use, seen by reps & supers only
export const toggleSendBillingDialog = (
  sendBillingDialogOpen = false,
  data
) => ({
  type: "TOGGLE_SEND_BILLING_DIALOG",
  sendBillingDialogOpen,
  data: data,
})

export const toggleClickConfirmationDialog = (
  clickConfirmationDialogOpen = false,
  data
) => ({
  type: "TOGGLE_CLICK_CONFIRMATION_DIALOG",
  clickConfirmationDialogOpen,
  data: data,
})

export const toggleFlaggingDialog = (flaggingDialogOpen = false, data) => ({
  type: "TOGGLE_FLAGGING_DIALOG",
  flaggingDialogOpen,
  data: data,
})

export const toggleCreateSoloDialog = (createSoloDialogOpen = false, data) => ({
  type: "TOGGLE_CREATE_SOLO_DIALOG",
  createSoloDialogOpen,
  data: data,
})

export const toggleClientInvoiceLogsDialog = (ClientInvoiceLogsDialogOpen = false, data) => ({
  type: "TOGGLE_CLIENT_INVOICE_LOGS_DIALOG",
  ClientInvoiceLogsDialogOpen,
  data: data,
})

export const toggleManageExpensesDialog = (
  manageExpensesDialogOpen = false,
  data
) => ({
  type: "TOGGLE_MANAGE_EXPENSES_DIALOG",
  manageExpensesDialogOpen,
  data: data,
})

export const toggleAddSoloPositionDialog = (
  addSoloPositionDialogOpen = false,
  data
) => ({
  type: "TOGGLE_ADD_SOLO_POSITION_DIALOG",
  addSoloPositionDialogOpen,
  data: data,
})

export const togglePayNowDialog = (payNowDialogOpen = false, data) => ({
  type: "TOGGLE_PAY_NOW_DIALOG",
  payNowDialogOpen,
  data: data,
})

export const toggleViewTransfersDialog = (
  viewTransfersDialogOpen = false,
  data
) => ({
  type: "TOGGLE_VIEW_TRANSFERS_DIALOG",
  viewTransfersDialogOpen,
  data: data,
})

export const toggleBillingAdjustmentDialog = (
  billingAdjustmentDialogOpen = false,
  data
) => ({
  type: "TOGGLE_BILLING_ADJUSTMENT_DIALOG",
  billingAdjustmentDialogOpen,
  data: data,
})

export const toggleSoloRepresentativeDialog = (
  soloRepDialogOpen = false,
  data
) => ({
  type: "TOGGLE_SOLO_REPRESENTATIVE_DIALOG",
  soloRepDialogOpen,
  data: data,
})
